import React, { useState } from "react";
import Navbar from "./Navbar/index"; // Assure-toi du chemin correct
import Sidebar from "../components/Sidebar/index"; // Assure-toi du chemin correct
import Footer from "./Footer/index"; // Assure-toi du chemin correct
import { Outlet, useLocation } from "react-router-dom"; // Importer useLocation pour récupérer l'URL actuelle

const Layout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation(); // Récupérer l'URL actuelle

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      
      <Outlet /> {/* Ceci affichera les pages spécifiques en fonction de la route */}
      
      {/* Afficher le footer sauf pour la page /rides */}
      {location.pathname !== '/rides' && <Footer />}
    </>
  );
};

export default Layout;
